(function () {
  const productCache = new Map();

  function uniqueOptionValues(product, optionPosition) {
    const key = `option${optionPosition + 1}`;
    const seen = new Set();
    const values = [];

    for (const variant of product.variants || []) {
      const value = variant[key];
      if (!value || seen.has(value)) continue;
      seen.add(value);
      values.push(value);
    }

    return values;
  }

  function variantForEnglishValue(product, optionPosition, englishValue) {
    const key = `option${optionPosition + 1}`;
    return (product.variants || []).find((variant) => variant[key] === englishValue) || null;
  }

  function featuredImageSrc(variant) {
    const image = variant && variant.featured_image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || '';
  }

  async function loadProduct(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);

    const request = fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('product.js failed');
        return response.json();
      })
      .catch(() => null);

    productCache.set(handle, request);
    return request;
  }

  function bindSwatchHover(swatch) {
    if (swatch.dataset.lwSwatchHoverReady === 'true') return;

    const imageSrc = swatch.dataset.imageSrc;
    if (!imageSrc) return;

    const card = swatch.closest('.card');
    const image = card ? card.querySelector('.card-image--primary') : null;
    if (!image) return;

    swatch.dataset.lwSwatchHoverReady = 'true';

    const storeOriginal = () => {
      if (image.dataset.originalSrc) return;
      image.dataset.originalSrc = image.getAttribute('src') || '';
      image.dataset.originalSrcset = image.getAttribute('srcset') || '';
      image.dataset.originalSizes = image.getAttribute('sizes') || '';
      image.dataset.originalAlt = image.getAttribute('alt') || '';
    };

    const showSwatchImage = () => {
      storeOriginal();
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = imageSrc;
      if (swatch.dataset.imageAlt) image.alt = swatch.dataset.imageAlt;
    };

    const restoreOriginalImage = () => {
      if (!image.dataset.originalSrc) return;
      image.src = image.dataset.originalSrc;
      if (image.dataset.originalSrcset) image.setAttribute('srcset', image.dataset.originalSrcset);
      if (image.dataset.originalSizes) image.setAttribute('sizes', image.dataset.originalSizes);
      image.alt = image.dataset.originalAlt || '';
    };

    swatch.addEventListener('mouseenter', showSwatchImage);
    swatch.addEventListener('mouseleave', restoreOriginalImage);
    swatch.addEventListener('focus', showSwatchImage);
    swatch.addEventListener('blur', restoreOriginalImage);
  }

  async function applySwatch(el) {
    if (el.dataset.variantColor || el.hasAttribute('data-lw-swatch-has-color')) {
      bindSwatchHover(el);
      return;
    }

    const handle = el.dataset.productHandle;
    const optionPosition = Number.parseInt(el.dataset.optionPosition || '', 10);
    const valueIndex = Number.parseInt(el.dataset.valueIndex || '', 10);

    if (!handle || Number.isNaN(optionPosition) || Number.isNaN(valueIndex)) return;

    const product = await loadProduct(handle);
    if (!product || !window.LwSwatchColors) return;

    const englishValues = uniqueOptionValues(product, optionPosition);
    const englishValue = englishValues[valueIndex];
    if (!englishValue) return;

    const variant = variantForEnglishValue(product, optionPosition, englishValue);
    const candidates = [variant?.sku, variant?.barcode, englishValue].filter(Boolean);
    let hex = null;

    for (const candidate of candidates) {
      const next = window.LwSwatchColors.hex(candidate);
      if (next !== '#808080') {
        hex = next;
        break;
      }
    }

    if (hex) {
      el.style.backgroundColor = hex;
      el.style.backgroundImage = '';
    }

    const imageSrc = featuredImageSrc(variant);
    if (imageSrc) {
      el.dataset.imageSrc = imageSrc;
      const imageAlt =
        (variant.featured_image && typeof variant.featured_image === 'object' && variant.featured_image.alt) ||
        product.title ||
        '';
      if (imageAlt) el.dataset.imageAlt = imageAlt;
    }

    bindSwatchHover(el);
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-lw-swatch]:not([data-lw-swatch-color-ready])').forEach((el) => {
      el.dataset.lwSwatchColorReady = 'true';
      applySwatch(el);
    });

    scope.querySelectorAll('.card-color-swatch[data-image-src]:not([data-lw-swatch-hover-ready])').forEach((el) => {
      bindSwatchHover(el);
    });
  }

  window.LwPlpSwatches = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
